var angular=window.angular,ngModule;
try {ngModule=angular.module(["views"])}
catch(e){ngModule=angular.module("views",[])}
var v1="<button class=\"btn btn-link btn-xs {{$ctrl.hasImages?'btn-primary':''}}\" type=\"button\" ng-click=\"$ctrl.prompt($ctrl.context, $ctrl.contextId)\" uib-tooltip=\"View Images\" tooltip-append-to-body=\"true\" tooltip-placement=\"top\"><i class=\"fa fa-lg fa-picture-o\"></i></button>";
var id1="image-manager.htm";
var inj=angular.element(window.document).injector();
if(inj){inj.get("$templateCache").put(id1,v1);}
else{ngModule.run(["$templateCache",function(c){c.put(id1,v1)}]);}
module.exports=id1;